export enum CustomHeaders {
	CurrentUserId = 'X-User-ID',
}
